<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline';
import Chip from 'primevue/chip';
import type { ITransactionType } from '~/interfaces/dto/wallet/transactions';

withDefaults(
  defineProps<{ selectedTransactionTypes: ITransactionType[] | null }>(),
  {
    selectedTransactionTypes: null,
  },
);

const emit = defineEmits<{
  (e: 'remove-selected', transactionTypeCategoryId: string): void;
}>();
</script>

<template>
  <UserInterfaceGenericCarousel
    v-if="selectedTransactionTypes?.length > 1"
    id="selected-transaction-types"
    title="selected-transaction-types"
    titleClass="text-xl"
    class="!gap-1"
    :display-arrows="false"
    :display-title="false"
    :display-show-all="false"
  >
    <Chip
      v-for="transactionType in selectedTransactionTypes"
      :key="transactionType.description"
      removable
      :label="transactionType.description"
      :pt="{
        root: '!w-fit min-w-fit flex items-center gap-1.5 truncate text-xs text-base-priority text-ellipsis capitalize py-1.5 px-1.5 std-border dark:bg-dark-600 bg-light-200 rounded-lg',
        removeIcon: 'rounded-full',
      }"
      @click="
        emit('remove-selected', transactionType.transactionTypeCategoryId)
      "
    >
      <template #removeicon="{ removeCallback }">
        <XMarkIcon class="w-4 h-4" @click="removeCallback" />
      </template>
    </Chip>
  </UserInterfaceGenericCarousel>
</template>
